const themeOptions = {
    pColor : '#ffc500',
    sColor: 'black'
}

export default themeOptions;